//Safe.Utils = {};

Safe.Utils.handleErrorsFromXML = function (xml) {
    if(!xml.responseXML){
        return;
    }
    var errors = xml.responseXML.getElementsByTagName("errorMessage");
    if (errors.length > 0) {
        Safe.MessageManager.addError(errors[0].textContent);
        return;
    }
};

Safe.Utils.getPersistentObjectInfo = function (id, properties) {

    this.done = function (callback) {
        var params = new FormData();
        params.append('id', id);
        params.append('properties', properties.join(','));

        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function() {

            if (this.readyState == 4 && this.status == 200) {
                Safe.Utils.handleErrorsFromXML(this);
                callback(this);
            }
        };

        xhr.open("POST", "./PersistentObjectXMLInfo.do", true);
        xhr.send(params);
    };
    return this;
};
Safe.Utils.Progress = function () {

    var indicator = document.querySelector('#globalLoader');

    this.show = function () {
        indicator.style.display = 'block';
    };
    this.hide = function () {
        indicator.style.display = 'none';
    }
};

Safe.Utils.parseURLParams = function (){
    var searchParams = new URLSearchParams(location.search);
    var queryObject = {};
    for(const[key,value] of searchParams){
        queryObject[key] = value;
    }
    return queryObject;
};

Safe.Utils.escapeHtml = function(text){
        var map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;',
            " ": '&nbsp;'
        };
    return text.replace(/[&<>"']/g, function(m) { return map[m]; });
};

Safe.Utils.getElementDimensions = function(element){
    var display = getComputedStyle(element).display;
    if (display && display !== 'none') {
        return { width: element.offsetWidth, height: element.offsetHeight };
    }else{
        const visibilityOld = getComputedStyle(element).visibility;
        element.style.visibility = 'hidden';
        element.style.display = 'block';
        var dimensions = {
            width:  element.offsetWidth,
            height: element.offsetHeight
        };
        element.style.visibility(visibilityOld);
        element.style.display = 'none';
    return dimensions;
    }
};

Safe.Utils.Locale = {};

Safe.Utils.Locale.setLocale = function(locale) {
    var xhr = new XMLHttpRequest();
    xhr.open("POST", "./ChangeLocaleAction.do", true);
    var params = {
        'newLocale' : locale
    };

    xhr.onreadystatechange = function() {
        if (xhr.readyState === XMLHttpRequest.DONE && xhr.response) {
            var resp = JSON.parse(xhr.response);
            if (resp.errorMessage) {
                Safe.MessageManager.addError(resp.errorMessage);
                return;
            }
            if (resp.locale) {
                //setLocationToUrl(window.location.href);
               window.location.replace(location.pathname.replace("Login.do", "MainPage.do") + location.search);
            }
        }
    };
    xhr.send(JSON.stringify(params));
};

Safe.Utils.CSS = {};

Safe.Utils.CSS.escape = function(string) {
    return string.replace(/\[/g, '\\\[').replace(/\]/g, '\\\]').replace(/\./g, '\\\.');
};

Safe.Utils.includes = function(array, item) {
    if (!array || !item) {
        return false;
    }
    var i;
    for (i = 0; i < array.length; i++) {
        if (array[i] === item) {
            return true;
        }
    }
    return false;
};

Safe.Utils.isMobile = function() {
    return (/iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(navigator.userAgent)) || (/iPad|Android/i.test(navigator.userAgent) && /Mobile/i.test(navigator.userAgent) === false);
};

Safe.Utils.getElementByHelper = function(node, helper) {
    node.querySelector('*[data-safe-event-helper="' + helper + '"]')
};

Safe.Utils.showSwitchMobileView = function(responsive){
    if(responsive){
        document.querySelector(".mobile_switch_mobile").setStyle({display: 'none'});
    }else{
        document.querySelector(".mobile_switch_desktop").setStyle({display: 'none'});
    }
    if(Safe.Utils.isMobile()){
        document.querySelector(".mobile_switch_view").classList.remove("hide");
    }
}

Safe.Utils.switchMobileView = function(responsive){
    setRegistry("www.layout.responsive", !responsive, true);
    location.reload();
}

Safe.Utils.isValidJSON = function(str) {
    try {
        JSON.parse(str);
        return true;
    } catch (e) {
        return false;
    }
}

/**
 *  Lokalizovane texty hlasek
 * */
Safe.Utils.localizedStrings = {
    emptyItems: {
        'cs': 'Nebyly vybrány žádné položky.',
        'en': 'No items have been selected.',
        'sk': 'Neboli vybrané žiadne položky.'
    },
    save: {
        'cs': 'Uložit změny',
        'en': 'Save',
        'sk': 'Uloženie zmien'
    },
    cancel: {
        'cs': 'Storno',
        'en': 'Cancel',
        'sk': 'Storno'
    },
}